// Copyright (c) 2016 Deere & Company

import PipClaimContainer from '../../claim/pip/state-connector';

export default {
    component: PipClaimContainer,
    name: 'PIP',
    path: 'pip/new(/:pin)(/:pipId)'
};



// WEBPACK FOOTER //
// ./src/routes/claims/pip-claim-route-with-pin-and-pip-id.js